import $ from 'jquery'
import { trace } from 'rytm-helpers'

const onSearchOffcanvasShown = (e) => {
  const input = e.target.querySelector("input")
  if (input) {
    input.focus()
  }
}

export const initSearchFocus = () => {
  // offcanvas focus on input (global search)
  document.addEventListener("shown.bs.offcanvas", onSearchOffcanvasShown)
}